//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: ${({ marginTop  = 0 }) => marginTop};
    & h5, span {
        font-size: 14px;
    }
    & h5 {
        margin: 5px 0;
        font-weight: bold;
    }
`;